<template lang="pug">
  v-card( elevation="1").px-4.py-3
    v-card-title
      span {{ title }}
    v-card-text
      v-layout(row wrap )
        template(v-for="i in computedValue.length")
          v-flex(xs7)
            v-text-field(label="メールアドレス" v-model="computedValue[i-1].email" :error-messages="getErrorMessages( label +  '[' + (i-1) + '].email')")
          v-flex(xs5)
            v-text-field(label="備考" v-model="computedValue[i-1].remark" :error-messages="getErrorMessages( label +  '[' + (i-1) + '].remark')")

</template>
<script>
export default {
  name: "DestinationMailAddress",
  props: {
    value: {
      required: true,
      type: Array,
      default: () => []
    },
    errors: {
      type: Object,
      required: true
    },
    rowCount: {
      type: Number,
      default: 3
    },
    label: {
      type: String,
      default: "mails"
    },
    title: {
      type: String,
      default: "送信先メールアドレス"
    }
  },
  data: function () {
    return {
      records: []
    };
  },
  computed: {
    computedValue: {
      get() {
        return this.value;
      },
      set(newValue) {
        // 値が変更されたときに 'input' イベントを発行する
        // これにより、親コンポーネントの v-model が更新される
        this.$emit("input", newValue);
      }
    }
  },
  methods: {
    initMails: function () {
      if (this.computedValue.length < this.rowCount) {
        for (let i = this.rowCount - this.computedValue.length; i > 0; i--) {
          this.computedValue.push({
            email: null,
            remark: null
          });
        }
      }
    },
    getErrorMessages(fieldId) {
      if (this.errors[fieldId] == null) {
        return "";
      } else {
        return this.errors[fieldId].join("\n");
      }
    }
  }
};
</script>
